﻿import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button, Stack, Card, Container } from "@mui/material";
import PopUp from "@/components/PopUp/PopUp";
import SettingsPopUp from "@/components/Settings/SettingsPopUp";
import "./SummaryCard.css";
import {
  selectCurrentOperationId,
  selectCurrentOperationName,
} from "@/features/operations/operationsSlice";
import {
  SummaryInactive,
  SummaryHover,
  ManagerInactive,
  ManagerHover,
  SupportInactive,
  SupportHover,
} from "../../ImageRepo";

const DocumentCount = ({ count, desc }) => {
  return (
    <Box
      style={{
        display: "flex",
        justifyContent: "flex-start",
        columnGap: 7,
        marginBottom: "auto",
      }}
    >
      <Typography
        variant="h2"
        style={{
          fontSize: "var(--font-xl)",
          fontWeight: "var(--font-bold)",
          color: "var(--primary-main)",
        }}
      >
        {count}
      </Typography>
      <Typography
        variant="body1"
        style={{
          color: "var(--primary-main)",
          paddingTop: 8,
        }}
      >
        {desc}
      </Typography>
    </Box>
  );
};

const LinkButton = ({ label, onClick, imgSrc, imgSrcHover }) => {
  return (
    <Button className={"link-button"} variant="contained" onClick={onClick}>
      <Stack
        direction={"row"}
        justifyContent={"flex-start"}
        style={{ width: "100%" }}
      >
        <img className="button-icon inactive" src={imgSrc} />
        <img className="button-icon hover" src={imgSrcHover} />
        <Box>{label}</Box>
      </Stack>
    </Button>
  );
};

const SummaryCard = ({ screenName }) => {
  const navigate = useNavigate();

  const [settingsOpenPopUp, setSettingsOpenPopUp] = useState(false);
  const currentOperationName = useSelector(selectCurrentOperationName);
  const currentOperationId = useSelector(selectCurrentOperationId);

  let summary = [
    { count: 0, desc: "New Orders Received" },
    { count: 10, desc: "New Orders are Held In-Process" },
    { count: 30, desc: "New Orders Completed and Sent" },
  ];

  const onClickInboundOutboundMap = () => {
    if (currentOperationId === null) {
      alert(
        "Please select a valid operation before trying to Inbound / Outbound Map"
      );
      return;
    }
    navigate("/map-schema");
  };

  return (
    <Container>
      <Card
        style={{
          display: "flex",
          justifyContent: "flex-start",
          margin: "unset",
        }}
      >
        <Box>
          <img
            className="icon"
            src={screenName === "summary" ? SummaryInactive : ManagerInactive}
          />
        </Box>
        <Box style={{ maxWidth: 800, marginLeft: 30 }}>
          <Typography gutterBottom variant="h1" style={{ marginBottom: 12 }}>
            {screenName === "summary" ? "Summary" : "Manager"}
          </Typography>
          <Box style={{ height: 21 }}>
            {currentOperationName != null && (
              <Typography
                variant="h3"
                style={{ fontWeight: "var(--font-regular)" }}
              >
                Filter by - <strong>{currentOperationName}</strong>
              </Typography>
            )}
          </Box>
          <Box style={{ marginTop: 12 }}>
            {summary.map((record, i) => (
              <DocumentCount key={i} count={record.count} desc={record.desc} />
            ))}
          </Box>

          <Typography
            variant="body2"
            className="ordertoinvoice-summary-lastupdate"
          >
            Last Update: June-07-2023
          </Typography>
        </Box>
        <Box
          style={{
            marginLeft: "auto",
            marginRight: 40,
          }}
        >
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            style={{ width: 612 }}
          >
            {screenName === "summary" && (
              <LinkButton
                onClick={() => navigate("/manager")}
                label={"Manager"}
                imgSrc={ManagerInactive}
                imgSrcHover={ManagerHover}
              />
            )}
            {screenName === "manager" && (
              <LinkButton
                onClick={() => navigate("/summary")}
                label={"Summary"}
                imgSrc={SummaryInactive}
                imgSrcHover={SummaryHover}
              />
            )}
            <LinkButton
              onClick={() => setSettingsOpenPopUp(true)}
              label={"Settings"}
              imgSrc={SupportInactive}
              imgSrcHover={SupportHover}
            />

            <PopUp
              size={"large"}
              openPopUp={settingsOpenPopUp}
              setOpenPopUp={setSettingsOpenPopUp}
            >
              <SettingsPopUp onClose={() => navigate("/settings")} />
            </PopUp>
          </Stack>
        </Box>
        <Box>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <LinkButton
              onClick={onClickInboundOutboundMap}
              label={"Inbound / Outbound Map"}
            />
          </Stack>
        </Box>
      </Card>
    </Container>
  );
};

export default SummaryCard;
export { LinkButton };
